const focusElement = (el) => {
  if (!el) {
    return;
  }
  el.focus();
  el.dispatchEvent(new Event("focus", { bubbles: true }));
};
const blurElement = (el) => {
  if (!el) {
    return;
  }
  el.blur();
  el.dispatchEvent(new Event("blur", { bubbles: true }));
};
export {
  blurElement as b,
  focusElement as f
};
//# sourceMappingURL=focus-7a563842.mjs.map
